<template>
  <div>
    <header-portrate />
    <exports-print ref="exportbar" />
    
  <div>
    <bread-crumbs :items='items' />
    <tabsComp :tabs="tabs" />
    
    <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:-35px !important;`">
      <v-row style="margin-top:45px;">

        <v-col cols="12" md="12">
          <form autocomplete="off">
            <div class="searchTop" style="margin-inline-end:-20px !important;">
              <div class="searchBar">
                <div>
                  <div>{{lang.chose_from_list}} {{lang.start_date}}</div>
                  <b-input-group>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="sd.day" :options="daysList"/>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="sd.month" :options="monthsList" />
                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="sd.year" :options="yearsList" />
                  </b-input-group>
                </div>

                <div>
                  <div>{{lang.chose_from_list}} {{lang.end_date}}</div>
                  <b-input-group>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="ed.day" :options="daysList"/>
                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="ed.month" :options="monthsList" />
                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="ed.year" :options="yearsList" />
                  </b-input-group>
                </div>

               
                <div>
                  <div>&nbsp;</div>
                  <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;"  @click="getStatics()">{{lang.search}}</b-button>
                </div>
              </div>
              <div style="margin-inline-end:17px;">
                
              </div>
            </div>
          </form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" :style="`direction:`+lang.dir+`;`">
          <v-row>
            <v-col v-for="(item,index) in tbrows" :key="index" cols="12" md="3" :style="`direction:`+lang.dir+`;`">
              <div style="border:1px solid #000;margin:5px;text-align:center;background:blue; color:#fff;padding:5px;">{{ item.text }}</div>
              <div style="border:1px solid #000;margin:5px;text-align:center;padding:5px;">{{ item.value }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <div class="loadingPage" v-if="$store.state.showLoading">
      <v-progress-circular
          :width="3"
          color="green"
          indeterminate
      ></v-progress-circular>
        <div style="padding:3px;">يرجى الانتظار ... Please Wait</div>
      </div>
    <vue-snotify></vue-snotify>
  </div>
  
  <Footer />
  </div>
</template>

<script>
import axios from 'axios'
// import addNewInvoice from '@/components/addNewInvoice.vue'
import {SnotifyPosition} from 'vue-snotify';
import BreadCrumbs from '@/components/breadCrumbs.vue'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import tabsComp from '@/components/tabsComp.vue'
import ExportsPrint from '@/components/exports-print.vue';

  export default{
    name: 'Invoicelist',
    components: {
        BreadCrumbs,
        Footer,
        HeaderPortrate,
        tabsComp,
        ExportsPrint,
    },
    data() {
      return {
        tbrows: [
          {text: 'الفواتير', value: 250},
          {text: 'فواتير غير مسددة', value: 250},
          {text: 'عروض اسعر', value: 250},
          {text: 'عدد العملاء', value: 250},
          {text: 'عملاء تحت التفاوض', value: 250},
          {text: 'تم ارسال ديمو', value: 250},
          {text: 'تم ارسال عرض سعر', value: 250},
          {text: 'تم الشراء', value: 250},
        ],
        pl: {
          c1: '',
          c2: '',
          c3: '',
          text: ''
        },
        allres: 0,
        cpage: 0,
        search: '',
        drow: false,
        page: 1,
        pageCount:0,
        edinvoice: 0,
        
        // sdate: new Date().toISOString().substring(0, 10),
        // edate: new Date().toISOString().substring(0, 10),
        mobile: '',
        excel_fields:{},
        tablerows: [
          
        ],
        ishome: true,
        viewInvoice: false,
        invoice_number: '',
        sd: {
          day: (new Date()).getDate(),
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        ed: {
          day: (new Date()).getDate(),
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        totaling: {
          total: 0,
          vat: 0,
          ftotal: 0,
          paid: 0,
          reamin: 0,
          cash: 0,
          other: 0,
          costs: 0,
          profits: 0
        }
      }
    },
    computed: {
      plate_number: function(){
        if(this.pl.c1 == '' && this.pl.c2 == '' && this.pl.c3 == ''  && this.pl.text == ''){
          return '';
        }
        return this.pl.c1 + " " + this.pl.c2 + " " + this.pl.c3 + " " + this.pl.text
      },
      cTblColspan: function(){
        let t = 13
        if(this.$store.state.licenseType.cars || this.$store.state.licenseType.carinfo){
          t++;
        }
        if(this.$store.state.licenseType.cars || this.$store.state.licenseType.carinfo || this.$store.state.licenseType.showPlate){
          t++;
        }
        if(this.$store.state.licenseType.cars || this.$store.state.licenseType.carinfo || this.$store.state.licenseType.parts || this.$store.state.licenseType.showPlate){
          t++;
        }
        if(this.$store.state.licenseType.cars || this.$store.state.licenseType.parts || this.$store.state.licenseType.carinfo){
          t++;
        }
        if(this.$store.state.licenseType.showCosts){
          t++;
        }
        if(this.$store.state.licenseType.showProfits){
          t++;
        }
        if(this.$store.state.group_id == 1 && this.$store.state.licenseType.showAddedBy){
          t++;
        }

        return t;
      },
      tblColspan: function(){
        return 13
      },
      cpages: function(){
        // alert(parseFloat(this.page) * 15);
        // alert(this.pageCount);
        if(parseFloat(this.page) * 15 >= this.allres){
          return true
        }
        return false;
      },
      testDate: function(){
        let t = '';
        const da = new Date();
        t = da.getSeconds();
        // console.log("this is test for time ",t);
        return t;
      },
      lang: function(){
          if(this.$cookies.get(this.$store.state.LangCooki) != null){
              if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
              return this.$store.state.lang.en;
              }else{
              return this.$store.state.lang.ar;
              }
          }
          else if(this.$store.state.deflang == 'en'){
              return this.$store.state.lang.en;
          }else{
              return this.$store.state.lang.ar;
          }
      },
      tablerowsF: function(){
        let t = [];
        for(let i=0;i<this.tablerows.length;i++){
          let s = {};
          Object.keys(this.tablerows[i]).forEach(key =>{
            if(key == 'total' || key == 'vat' || key == 'ftotal' || key == 'paid' || key == 'remain'){
              s[key] = parseFloat(this.tablerows[i][key]);
            }else{
              s[key] = this.tablerows[i][key]
            }
          })
          t.push(s)
        }
        return t;
      },
      sdate: function() {
        return (new Date(this.sd.year,this.sd.month-1, this.sd.day+1)).toISOString().substring(0,10);
      },
      edate: function() {
        return (new Date(this.ed.year,this.ed.month-1, this.ed.day+1)).toISOString().substring(0,10);
      },
      yearsList: function(){
        const start_year = this.$store.state.licenseType.startYear;
        let t = [{text: this.lang.year, value: -1}];
        for(let i=0;i<100;i++){
          if(parseInt(start_year) + i <= (new Date()).getFullYear()){
            t.push({text: start_year + i, value: start_year+i})
          }
          
        }
        return t
      },
      daysList: function(){
        return [
          {text: this.lang.day, value: -1},
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
          {text: 8, value: 8},
          {text: 9, value: 9},
          {text: 10, value: 10},
          {text: 11, value: 11},
          {text: 12, value: 12},
          {text: 13, value: 13},
          {text: 14, value: 14},
          {text: 15, value: 15},
          {text: 16, value: 16},
          {text: 17, value: 17},
          {text: 18, value: 18},
          {text: 19, value: 19},
          {text: 20, value: 20},
          {text: 21, value: 21},
          {text: 22, value: 22},
          {text: 23, value: 23},
          {text: 24, value: 24},
          {text: 25, value: 25},
          {text: 26, value: 26},
          {text: 27, value: 27},
          {text: 28, value: 28},
          {text: 29, value: 29},
          {text: 30, value: 30},
          {text: 31, value: 31},
        ]
      },
      monthsList: function(){
        return [
          {text: this.lang.chose_month, value: -1},
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
          {text: 8, value: 8},
          {text: 9, value: 9},
          {text: 10, value: 10},
          {text: 11, value: 11},
          {text: 12, value: 12},
        ]
      },
      items:function() {
          return {
            text: this.lang.invoices,
            disabled: true,
            href: '/invoicelist/',
          }
      },
      headers: function () {
        let x =  [
            { 
              text: "#", align: 'center',
              filterable: false, value: 'invoice_number',
              sortable: false,class: 'backBlack',perm: 'any'
            },
            { 
              text: this.lang.customer_type, align: 'center',
              filterable: false, value: 'customer_type',
              sortable: false,class: 'backBlack', perm: 'not_yes'
            },
            {
              text: this.lang.invtype, align: 'center',
              filterable: false, value: 'invtype',
              sortable: false,class: 'backBlack', perm: 'not_yes'
            },
            {
              text: this.lang.customer, align: 'center',
              filterable: false, value: 'full_name',
              sortable: false,class: 'backBlack', perm: 'any'
            },
            {
              text: this.lang.mobile, align: 'center',
              filterable: true, value: 'mobile',
              sortable: false, class: 'backBlack', perm: 'any'
            },
        ];
        if(this.$store.state.licenseType.cars || this.$store.state.licenseType.carinfo || this.$store.state.licenseType.showPlate){
          x.push({
              text: this.lang.plate, align: 'center',
              filterable: true, value: 'plate_number',
              sortable: false,class: 'backBlack', pem: 'any'
            });
            x.push({
                text: this.lang.car_model, align: 'center',
                filterable: false, value: 'model',
                sortable: false,class: 'backBlack',perm: "any"
                });
        // }
        // else if(this.$store.state.licenseType.parts){
        //   x.push({
        //       text: this.lang.model, align: 'center',
        //       filterable: false, value: 'model',
        //       sortable: false,class: 'backBlack'
        //       });
        }


          x.push({
            text: this.lang.inv_date, align: 'center',
            filterable: false, value: 'inv_date',
            sortable: false,class: 'backBlack', perm: 'any'
          })
              ,
          // x.push({
          //     text: this.lang.total, align: 'center',
          //     filterable: false, value: 'total',
          //     sortable: false,class: 'backGreen'
          //   })
          x.push({
              text: this.lang.fftotal, align: 'center',
              filterable: false, value: 'ftotal',
              sortable: false,class: 'backBlack', perm: 'not_yes'
            })
          
          x.push({
              text: this.lang.vat, align: 'center',
              filterable: false, value: 'vat',
              sortable: false,class: 'backBlack', perm: 'not_yes'
            });
          x.push({
              text: this.lang.ftotal, align: 'center',
              filterable: false, value: 'vat',
              sortable: false,class: 'backBlack', perm: 'any'
            });
          
          x.push({
              text: this.lang.paid, align: 'center',
              filterable: true, value: 'paid',
              sortable: false,class: 'backBlack', perm: 'not_yes'
            })
        x.push({
          text: this.lang.cash, align: 'center',
          filterable: true, value: 'cash',
          sortable: false,class: 'backBlack', perm: 'not_yes'
        })
        x.push({
          text: this.lang.span, align: 'center',
          filterable: true, value: 'span',
          sortable: false,class: 'backBlack', perm: 'not_yes'
        })
        x.push({
            text: this.lang.remain, align: 'center',
            filterable: true, value: 'remain',
            sortable: false,class: 'backBlack',style: "border:1px solid #000 !important;", perm: 'not_yes'
          })
        if(this.$store.state.licenseType.showCosts){
          x.push({text: this.lang.costs,align:'center',value:"costs",filterable: false, sortable: false,class: 'backBlack', perm: 'not_yes'})
        }
        if(this.$store.state.licenseType.showProfits){
          x.push({text: this.lang.profit,align:'center',value:"profits",filterable: false, sortable: false,class: 'backBlack', perm: 'not_yes'})
        }
        if(this.$store.state.group_id == 1 && this.$store.state.licenseType.showAddedBy){
          x.push({
            text: this.lang.added_by, align: 'center', filterable: true,
            value: '_status', sortable: false,   class: 'backBlack' , perm: 'not_yes'
          });
        }
        x.push({
            text: this.lang.status, align: 'center', filterable: true,
            value: '_status', sortable: false,class: 'backBlack', perm: 'any'
          })
        x.push({
            text: this.lang.action, align: 'center',
            filterable: false, value: '',
            sortable: false,class: 'backBlue', perm: 'any'
          });
        
        return x;
      },
      tabs: function(){
        // console.log(this.$store.getters['state'].licenseType.activemenu);
        const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
              const cM = localStorage.getItem('currentMenu');
              // console.log("cM",cM);
              if(value.main.index == cM){
                  cMenu = value.sub;
              }else if(cM == null && value.main.index == 1){
                  cMenu = value.sub;
              }
            });
           
            let t = []
            // console.log("cMenu",cMenu);
            Object.values(cMenu).forEach(value =>{
            
                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                      if(alicense[value.perms[0]] || value.perms[0] == 'any')
                          t.push(value)
                    }
                }
            })
        
            return t;
      }
    },
    created() {
      //this.getStartDate();
      this.getStatics();
      //this.getExcelHead();
    },
    methods: {
      getStatics()
      {
        const post = new FormData();
        post.append('defBranch',localStorage.getItem('defBranch'));
        post.append('financeYear',localStorage.getItem('financeYear'));
        post.append('type', "getIntegratedAgents");
        post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
        post.append('data[agent]', 1)

        axios.post(
                this.$store.state.SAMCOTEC.r_path, post
        ).then((response) => {
            console.log("helloooo ",response)
        })

      },
      // $convertToComa(num){
      //       // // console.log(this.$store.state.licenseType.moneyComma);
      //     if(this.$store.state.licenseType.moneyComma){
      //         return Number(num).toLocaleString()
      //     }else{
      //         return num
      //     }
      // },
      collectSearch(){
        return {
          module: 'invoices',
          elements: {
            mobile: this.mobile,
            sdate: this.sdate,
            edate: this.edate,
            invoice_number: this.invoice_number,
            plate_number: this.plate_number,
            branchid: localStorage.getItem('defBranch'),
            financeYear: localStorage.getItem('financeYear'),
          }
        }
      },
      addInvoiceEd(){
        this.$refs.addingInvoice.getNewInvoiceID();
        this.$refs.addingInvoice.reset();
      },
      addInvoiceEdd(){
        this.$refs.addErpInvoice.reset();
      },
      getStartDate(){
        let d = (new Date()).getDate();
        let m = (new Date()).getMonth() + 1;
        let y = (new Date()).getFullYear();
        if(parseInt(d) < 30){
          d = parseInt(30) - parseInt(d);
          if(parseInt(m) == 1){
            m = 12
            y = parseInt(y) - 1
          }
          else if(parseInt(m) > 1){
            m = parseInt(m) - 1;
          }
        }else if(parseInt(d) == 30){
          d = 1;
        }else{
          d = parseInt(d) - parseInt(30);
        }
        //-- start date today
        // this.sd.day = (new Date()).getDate();
        // this.sd.month = (new Date()).getMonth() + 1;
        this.sd.day = 1;
        this.sd.month = 1;
        this.sd.year = y;
      },
      preparedata(){
        let exdata = {
            list: "invoiceList",
            title: this.lang.invoices,
            data: [],
        }
        for(let i=0;i<this.tablerowsF.length;i++){
            exdata.data.push(this.tablerowsF[i]);
        }
        // // console.log(exdata);
        this.$refs.exportbar.exportdata = exdata;
        this.$refs.exportbar.sdate = this.sdate;
        this.$refs.exportbar.edate = this.edate;
        
        this.$refs.exportbar.exporttitle = "";
        this.$refs.exportbar.palte_number = '';
        this.$refs.exportbar.contact_number = '';
      },
      cancelInvocie(item)
      {
          const invID = item.id;
          this.$snotify.confirm('هل أنت متاكد بانك تريد الغاء هذه الفاتورة؟ لا يمكن التراجع عن هذا االاجراء', 'تحذير', {
              timeout: 100000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              position: SnotifyPosition.centerCenter,
              buttons: [
                  {
                      text: 'متأكد', 
                      action: (toast) => {
                          this.doCancel(invID)
                          this.$snotify.remove(toast.id); 
                      },
                      bold: false
                  },
                  {
                      text: 'اغلاق', 
                      action: (toast) => {
                          this.$snotify.remove(toast.id); 
                      } 
                  },
              ]
          })
          if(!this.doitrelay){
              return false;
          }
      },
      doCancel(invID){
        if (this.$snotify.notifications.length > 0) {
            this.$snotify.notifications.forEach(notification => {
                this.$snotify.remove(notification.id)
            });
        }
        this.$snotify.error('يرجى اختيار سبب الالغاء'  , {
              timeout: 1000000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              
              position: SnotifyPosition.centerCenter,
              buttons: [
                  {
                      text: 'خطأ في الادخال', 
                      action: (toast) => {
                          this.doCancelIt(1,invID)
                          this.$snotify.remove(toast.id); 
                      },
                      bold: false
                  },
                  {
                      text: 'سوء الخدمة', 
                      action: (toast) => {
                          this.doCancelIt(2,invID)
                          this.$snotify.remove(toast.id); 
                      },
                      bold: false
                  },
                  {
                      text: 'السعر غير مناسب ', 
                      action: (toast) => {
                          this.doCancelIt(3,invID)
                          this.$snotify.remove(toast.id); 
                      },
                      bold: false
                  },
                  {
                      text: 'الغاء الامر', 
                      action: (toast) => {
                          this.$snotify.remove(toast.id); 
                      } 
                  },
              ]
          })
      },
      doCancelIt(id,invID){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            let cansel_reason = 'خطا في الادخال';
            if(id == 2){
              cansel_reason = 'سوء الخدمة';
            }
            else if(id == 3){
              cansel_reason = 'السعر غير مناسب';
            }
            post.append('type', 'cancelInvo');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',invID)
            post.append('data[cancel_reson]',cansel_reason)
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                if (this.$snotify.notifications.length > 0) {
                    this.$snotify.notifications.forEach(notification => {
                        this.$snotify.remove(notification.id)
                    });
                }
                this.$snotify.success('تم ارجاع الفاتورة بنجاح'  , {
                  timeout: 4000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true,
                  position: SnotifyPosition.centerCenter,
                });
                this.getCurrentCards();
            })
      },
      getInvo(item){
          this.$refs.popviewinv.invid = item.id;
          this.$refs.popviewinv.invoice = item;
          this.$refs.popviewinv.getInvoice();
          this.$refs.popviewinv.getInvoiceAdd();
          // this.$router.push({path: '/view-invoice/'+item.id})
      },
      revokit(item)
      {
          if (this.$snotify.notifications.length > 0) {
              this.$snotify.notifications.forEach(notification => {
                  this.$snotify.remove(notification.id)
              });
          }
          this.$snotify.error('هل أنت متأكد بانك تريد الغاء الفاتورة؟', 'تحذير', {
                timeout: 6000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                    {
                        text: 'متأكد', 
                        action: (toast) => {
                            this.cancelConfirmed();
                            this.$snotify.remove(toast.id); 
                        },
                        bold: false
                    },
                    {
                        text: 'اغلاق', 
                        action: (toast) => {
                            this.$snotify.remove(toast.id); 
                        } 
                    },
                ]
            })
      },
      printIt(item){
          window.open('../api/print.php?invid='+item.id,"_blank");
      },
      getExcelHead(){
        const head = this.headers;
        // for(var i=0;i< head.length;i++){
        //   const x = head[i].text;
        //   const y = head[i].value;
        //   this.excel_fields[x] = y;
        //   // // console.log("xx",this.excel_fields[x]);
        // }
      },
      gotoDaily(){
        this.$router.push({path: '/reports/daily-reports'})
      },
      PrintPage(){
        window.print();
      },
      sumField(key) {

        let x = this.tablerows.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
        x = +x *100;
        x = (Math.round(x)/100);
        // x = Number(x).toLocaleString()
        if(x != 0) return x;
        else return 0;
      },
      ViewItem(item){
        
        if(item.cardid == null || typeof item.cardid === 'undefined'){
          return false;
        }else{
          this.$router.push({ path: '/view-card/'+item.cardid });
        }
      },
      getNext(page){
        this.cpage = parseInt(page) - 1;
        this.getCurrentCards();
      },
      getCurrentCards(){
        const ds = new Date(this.sdate);
        const de = new Date(this.edate);
        if(ds.getTime() > de.getTime()){
            let message = "يجب ان يكون تاريخ البدء اقل من او يساوي تاريخ الانتهاء";
            this.$snotify.error(message, 'تنبيه', {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close, 
                        action: (toast) => {
                            this.$snotify.remove(toast.id); 
                        } 
                    },
                ]
            });
            this.invoice.payment.cash = this.full_ftotal
            if(this.invoice.payment.cash == 0) this.invoice.payment.cash = '';
            return false;
        }
        let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
        let post = new FormData();
        post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
        post.append('type','getAllInvoicesN'); 
        post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
        post.append('auth',cook);
        let data = {
          datatype: 'all',
          sdate: this.sdate,
          edate: this.edate,
          mobile: this.mobile,
          plate_number: this.plate_number,
          invoice_number: this.invoice_number,
        };
        post.append('data[datatype]',data.datatype);
        post.append('data[sdate]',data.sdate);
        post.append('data[cpage]',this.cpage);
        post.append('data[edate]',data.edate);
        post.append('data[mobile]',data.mobile);
        post.append('data[plate_number]',data.plate_number);
        post.append('data[invoice_number]',data.invoice_number);
        // this.tablerows = [];
        this.$store.state.showLoading = true;
        axios.post(
          this.$store.state.SAMCOTEC.r_path,
          post
        ).then((response) => {
          this.$store.state.showLoading = false;
          const res = response.data;
          // // console.log("الفواتير",res);
          if(typeof res.error !== 'undefined' && res.error != null && typeof res.error.number !== 'undefined'
              && res.error.number != null && res.error.number == 200){
                this.tablerows = res.results.data;
                this.totaling = res.results.totaling;
                // let p = parseInt(parseInt(res.results.data.length)/10);
                // this.page = p+1
                this.allres = res.results.allres
                this.pageCount = parseInt(parseInt(res.results.allres) / 15) + 1
                this.page = parseInt(this.cpage) + 1
              }
        })
      },
      ExportToExcel(){
        //
      },
    }
  }
</script>
<style>
.backBlue{
  background: blue !important;
  color: #fff !important;
  border-bottom: 1px solid #fff !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
}
.backGold{
  background: gold !important;
  color: #000 !important;
  border-bottom: 1px solid #fff !important;
  border-left: 1px solid #fff !important;
  border-right: 1px solid #fff !important;
}
.viewBTN{
  font-size:.8rem;
  background:blue !important;
  width:100%;
  color:#fff !important;
  height:25px !important;
  margin-left:5px;
  text-align:center;
  display:flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
}
.viewBTN:hover,.viewBTN:active,.viewBTN.viewBTN:click{
  background:blue !important;
  width:100%;color:#fff !important;
}
.loadingPage{
  position: fixed;
  left:0;
  right:0;
  top:0;
  bottom: 0;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  background:#ffffff00;
  z-index: 100000;
}
</style>
